import { render, staticRenderFns } from "./CustomerListComponent.vue?vue&type=template&id=6d2036cf&scoped=true&"
import script from "./CustomerListComponent.vue?vue&type=script&lang=js&"
export * from "./CustomerListComponent.vue?vue&type=script&lang=js&"
import style0 from "./CustomerListComponent.vue?vue&type=style&index=0&id=6d2036cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2036cf",
  null
  
)

export default component.exports